<template>
  <header class="entry-layout-header">
    <span class="entry-layout-header-logo">
      <img
        :src="logo"
        :style="logoStyle"
      />
    </span>
    <div class="entry-layout-menus">启航ERP</div>

    <AvatarDropdown />
    <!---客服系统入口--->
    <ServiceEnter
      :getQueryList="getQueryList"
      v-if="!isYST_user"
    />
  </header>
</template>

<script>
import { i18nRender } from '@/locales'
import { mapGetters } from 'vuex'
import AvatarDropdown from './AvatarDropdown.vue'
import ServiceEnter from '@/components/Tips/ServiceEnter'
import { QuerySystemParamsPage } from '@/api'
import { findPane } from '@/store/_util/util'
import { USER_INFO, ACCESS_TOKEN } from '@/store/mutation-types'

export default {
  name: 'EntryLayoutHeader',
  components: { AvatarDropdown, ServiceEnter },
  data() {
    const userInfo = this.$ls.get(USER_INFO)
    return {
      logo: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAdCAMAAABopjdHAAAAQlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////8IX9KGAAAAFXRSTlMAgMDw4BBgIFAwsECR0aBwqphYyIhPo2vqAAABDElEQVQoz22S3XbEIAiEg6DxP7vbzvu/agXjadJ0LhLgQ8ajbheVz779pz2jM/lH3ROADkj4A4IArn5yA1y6Gji4eK49BN0vgw6Ol7kVTBYRg9N9NCCjNeMEPlCmuBCOzQG2ncgAZrO10yBO40Q4FdTaiIVUCUtl5N2IerB8n3WWrLOVuGnZ3g1Aq8JVW5Voi42KK9CtKqmrwPsYsoxs2iKoG9+ImKGK508LSQn0usRqb/vSyA8lFiWb022JnnQz0jQMA7EoSNY4SH5Jt7ug6oB53V6+XrQVOypTKWkGbs7c7WAv8s6WWm+D+31PUdBXZv45aJoOQSu3CRWnODweojOgBg8VQZ4GT6Vr8gOUzBNDdAAY6QAAAABJRU5ErkJggg==',
      logoStyle: { display: 'inline-block', height: '28px' },
      userInfo,
      isFlag: false
    }
  },
  computed: {
    ...mapGetters(['serviceId', 'systemCode', 'panes', 'menus', 'activeKey']),
    // 检测是否为亿数通客户
    isYST_user() {
      return (
        this.userInfo && this.userInfo.classification && this.userInfo.classification === 'YST_PLUS'
      )
    }
  },
  methods: {
    i18nRender,
    // 神策埋点
    buriedShence(options = {}) {
      const { panes, iframes, activeKey } = this.$store.state.entry
      const activePane = [...panes, ...iframes].find((item) => item.key === activeKey)

      if (!activePane) return
      this.buriedShenceFlag = true
      this.$Shence.track(
        {
          p_na: activeKey === 'home' ? '首页' : activePane?.menuName?.zh_CN,
          ...options
        },
        'sea_bt'
      )
    },
    async getQueryList() {
      // const found = findPane(this.menus, { key: this.activeKey }, null, ['systemCode'])
      // const { systemCode } = found?.systemCode === 'BI' ? { systemCode: 'ERP' } : this.$route.params
      const { systemCode } = this.$route.params
      try {
        const params = {
          paging: false,
          systemGroup: 'ECS_CUSTOMER_CONFIG'
        }
        const { dataList } = await QuerySystemParamsPage(params)
        dataList.forEach((v) => {
          if (v.status === 2 && v.systemName === systemCode) {
            this.isFlag = true
            this.url = v.systemValue
          }
        })
        if (this.isFlag) {
          this.openSale1()
        } else {
          this.openSaleConsult()
        }
      } catch (error) {
        console.log(error)
      }
    },
    openSale1() {
      let menuName = '' // 当前的页面名称
      this.panes.forEach((v, i) => {
        if (v.key === this.activeKey) {
          menuName = v.tab
        }
      })
      const params = {
        token: this.$ls.get(ACCESS_TOKEN),
        menuId: this.activeKey,
        menuName
      }
      const found = findPane(this.menus, { key: this.activeKey }, null, ['systemCode'])

      if (found && typeof found.systemCode !== 'undefined') {
        params.systemCode = found.systemCode
      }
      const URL = `${this.url}?${Object.keys(params)
        .map((key) => `${key}=${params[key]}`)
        .join('&')}`
      window.open(URL, '_blank')
    },
    openSaleConsult() {
      const { systemCode } = this.$route.params
      this.$store.dispatch('OpenSaleConsult', systemCode)
    }
  }
}
</script>

<style lang="less" scoped>
.entry-layout-header {
  padding: 0 10px;
  display: flex;
  height: 42px;
  line-height: 42px;
  background: #1e1e28 url('../../assets/bg-erp-head.png') no-repeat 100% 100%;
  overflow: hidden;
}

.entry-layout-header-logo {
  margin: 0px;
  width: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

// 菜单样式
.entry-layout-menus {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  font-size: 20px;
  color: white;
}

.right-content {
  margin-right: 0px;
  display: inline-flex;
  height: 42px;
  line-height: 42px;

  &__action {
    display: inline-flex;
    color: #ffffff;
    font-size: 12px;
    white-space: nowrap;
    cursor: pointer;
    transition: all 0.3s;
    align-items: center;
    position: relative;

    &:hover {
      color: #1890ff;
    }
  }
}
</style>
